import { EntityLinks, Goal } from '@griply/types';

import { filterGoals } from './filter-goals';

export type RoadmapGoalFilterSettings = {
  hideUnplannedGoals?: boolean;
  hideCompletedGoals?: boolean;
  hideArchivedGoals?: boolean;
};

export const filterRoadmapGoals = (
  goals: Goal[],
  settings: RoadmapGoalFilterSettings,
  // Without it an archived parent's migrated children are not recognised as archived.
  links: EntityLinks,
): Goal[] =>
  filterGoals(goals, {
    links,
    hideUnplanned: settings.hideUnplannedGoals,
    hideCompleted: settings.hideCompletedGoals,
    hideArchived: settings.hideArchivedGoals ?? true,
  });
